import React, { useCallback, useEffect, useState } from 'react'
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import { Combobox } from '@headlessui/react'
import axios from 'axios'
import toast from 'react-hot-toast'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'

function classNames (...classes) {
  return classes.filter(Boolean).join(' ')
}

function IcdCode ({
  setSearchTerm,
  searchTerm,
  type,
  loading,
  setAcdItems,
  setLoading,
  setDropDownItems,
  dropDownItems,
  serviceType,
  serviceCode
}) {
  const [codes, setCodes] = useState([])
  const [textCode, setTextCode] = useState(null)
  const handelSearch = async inputText => {
    if (!inputText) return
    setLoading(true)
    try {
      const payload = { acd_code: inputText }
      const response = await axios.post(
        'https://code.supergitsa.com/api/Np7oaqcdD9QQTEaBDVh2FePkaxdDnOJoS8UCbhw5ZHJWGfxgKlTW',
        payload,
        {
          headers: {
            'api-key':
              '$2a$12$zRtmkEiCePG2YSjBOhtbveSpM./r6Sc7KR5TK0f8sPcQIykFwQf4O',
            'Content-Type': 'application/json'
          }
        }
      )
      setAcdItems(response?.data)
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Search failed')
    } finally {
      setLoading(false)
    }
  }

  const handelServiceSearch = async payload => {
    setLoading(true)
    try {
      const response = await axios.post(
        'https://code.supergitsa.com/api/Np7oaqcdD9QQTEaBDVh2FePkaxdDnOJoS8UCbhw5ZHJWGfxgKlTW',
        payload,
        {
          headers: {
            'api-key':
              '$2a$12$zRtmkEiCePG2YSjBOhtbveSpM./r6Sc7KR5TK0f8sPcQIykFwQf4O',
            'Content-Type': 'application/json'
          }
        }
      )
      if (dropDownItems.length === 0) {
        setDropDownItems(response?.data)
      } else {
        setAcdItems(response?.data)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Search failed')
    } finally {
      setLoading(false)
    }
  }

  const debouncedSearch = useCallback(debounce(handelSearch, 500), [])
  const debouncedServiceSearch = useCallback(
    debounce(handelServiceSearch, 500),
    []
  )

  const onSearch = inputText => {
    if (type === 'service_code') {
      debouncedServiceSearch(inputText)
    } else {
      debouncedSearch(inputText)
    }
  }
  useEffect(() => {
    debouncedServiceSearch({
      service_type: serviceType,
      service_code: serviceCode?.code
    })
  }, [serviceCode])
  useEffect(() => {
    setCodes(
      dropDownItems?.Services?.filter(
        item =>
          item.service_code?.includes(textCode) &&
          item.service_type === searchTerm.service_type
      ).slice(0, 10)
    )
  }, [textCode])
  const { t } = useTranslation()
  return (
    <Combobox as='div'>
      <div className='relative'>
        <Combobox.Input
          className='w-full rounded-md border border-gray-200 bg-gray-100 py-1 pl-3 pr-10 text-gray-900 ring-0 ring-inset ring-gray-100 focus:ring-[#0070C2] sm:text-[12px] sm:leading-6 h-[27px]'
          onChange={event => {
            const value = event.target.value
            if (type === 'service_code') {
              setTextCode(value)
            } else {
              onSearch(value)
            }
          }}
          placeholder={t('Search for Icd Code')}
          disabled={loading}
        />
        <Combobox.Button className='absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none'>
          <MagnifyingGlassIcon
            className='h-4 w-4 text-gray-400'
            aria-hidden='true'
          />
        </Combobox.Button>
      </div>
      {codes?.length > 0 && (
        <Combobox.Options className='mt-1'>
          {codes?.map(item => (
            <Combobox.Option
              onClick={() => {
                setSearchTerm(prev => {
                  const newSearchTerm = {
                    ...prev,
                    service_code: item?.service_code
                  }
                  onSearch(newSearchTerm)
                  return newSearchTerm
                })
              }}
              key={item?.service_code}
              value={item?.service_code}
              className={({ active }) =>
                classNames(
                  active ? 'text-primary bg-gray-100' : 'text-gray-900',
                  'cursor-pointer hover:text-gray-800 select-none py-2 px-4 rounded-md'
                )
              }
            >
              {item.service_description}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      )}
    </Combobox>
  )
}

export default React.memo(IcdCode)
